import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
} from "../../../../../../ui/AlertDialog/AlertDialog";
import { Button } from "../../../../../../ui/Button";
import { t } from "i18next";
import React, { useEffect } from "react";
import { useFetch } from "../../../../../../hooks/useFetch";

type Props = {
  id: string;
  shiftId: string;
  isDeleteOpen: boolean;
  closeModal: Function;
  refreshModels: Function;
  closeModalOnDelete: Function;
};

const DeleteBreak = ({ id, shiftId, isDeleteOpen, closeModal, refreshModels, closeModalOnDelete }: Props) => {
  const [{ response: deleteResponse, isLoading: deleteIsLoading, error: deleteError }, doFetchItemDelete] = useFetch(
    `/directories/working_shifts/${shiftId}/working_shift_breaks/${id}`
  );

  useEffect(() => {
    if (isDeleteOpen) {
      closeModal();
      closeModalOnDelete();
      refreshModels();
    }
  }, [deleteResponse]);

  const onDelete = () => {
    doFetchItemDelete({
      method: "DELETE",
    });
  };

  const openStateChange = () => {
    if (isDeleteOpen) closeModal();
  };

  return (
    <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
      <AlertDialogContent style={{ maxWidth: 450 }} className="gap-0">
        <AlertDialogTitle>Удалить перерыв</AlertDialogTitle>
        <AlertDialogDescription className="text-base">Вы уверены, что хотите удалить перерыв?</AlertDialogDescription>

        <div className="flex justify-between mt-4">
          <Button variant={"destructive"} size={"md"} className="px-3" onClick={onDelete}>
            {t("delete")}
          </Button>
          <AlertDialogCancel className="h-8">{t("cancel")}</AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteBreak;
